import { Divider } from 'antd';
import BottomSheet from '../../../../components/common/BottomSheet/BottomSheet';
import ButtonIconGhostMedium from '../../../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import ButtonSecondaryMedium from '../../../../components/common/ButtonSecondary/ButtonSecondaryMedium';
import { Icon } from '../../../../components/icon/icon';
import './RoomLibrary.scss';
import ButtonPrimaryLarge from '../../../../components/common/ButtonPrimary/ButtonPrimaryLarge';
import { useEffect, useState } from 'react';
import callApi from '../../../../utils/api/callAPI';
import { Empty } from 'antd';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const RoomLibrary = ({ open, onClose, setSidebarKey, onSelectRoom }) => {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [selectedRoomId, setSelectedRoomId] = useState(null);

  const { t } = useTranslation();

  const navigate = useNavigate();

  // Gọi API khi panel mở
  useEffect(() => {
    if (!open) return;

    const fetchRooms = async () => {
      setLoading(true);
      setErr('');
      try {
        const res = await callApi({
          endpoint: 'rooms/v3/users/rooms', // nhớ có slash đầu
          method: 'GET',
        });

        // chuẩn hoá payload
        const payload = res?.data;
        const list =
          payload?.result?.data ?? payload?.data ?? payload?.result ?? [];

        setRooms(Array.isArray(list) ? list : []);
      } catch (e) {
        setErr(
          e?.data?.error?.message ||
            e?.message ||
            t('Unable to load the room list')
        );
      } finally {
        setLoading(false);
      }
    };

    fetchRooms();
  }, [open]);

  const handleSelectRoom = room => {
    setSelectedRoomId(room.id || room._id);
  };

  // Handler khi nhấn nút "Tiếp theo"
  const handleContinue = () => {
    if (selectedRoomId && onSelectRoom) {
      onSelectRoom(selectedRoomId);
    }
    onClose?.();
  };

  return (
    <BottomSheet
      classNames={{
        title: 'flex justify-between self-stretch items-center',
        body: 'flex !p-0 justify-center items-center grow self-stretch room-library',
      }}
      title={
        <div className="flex items-center justify-between grow">
          <span className="text-headline-small">{t('Design space')}</span>
          <ButtonSecondaryMedium
            title={t('Back to homepage')}
            preIcon={<Icon.ICArrowForward />}
            onClick={() => {
              navigate('/');
            }}
          />
        </div>
      }
      open={open}
      onClose={() => {
        message.info(t('Please complete room selection before closing.'));
      }}
    >
      <div className="flex py-24 px-40 items-start align-content-start gap-16 grow self-stretch flex-wrap rounded-[8px] room-library-left overflow-auto">
        {/*  Button create  */}
        <div
          className="flex p-12 flex-col items-center justify-center rounded-[8px] gap-12 w-[290px] h-[322px] hover:bg-primary-primaryFill focus:bg-primary-primaryVarient1 shadow-dropshadow8"
          onClick={() => {
            setSidebarKey({ key: 'wallSetupForm', active: true });
            // setSidebarKey("wallSetupForm");
            if (onClose) onClose();
          }}
        >
          <span className="w-40 h-40 flex">
            <Icon.ICAdd />
          </span>
          <span className="text-body-large">{t('Create new room')}</span>
        </div>

        {!loading && err && (
          <div className="w-100 flex justify-center py-24">
            <span className="text-body-medium" style={{ color: '#ff4d4f' }}>
              {err}
            </span>
          </div>
        )}

        {!loading && !err && rooms.length === 0 && (
          <div className="w-100 flex justify-center py-24">
            <Empty description={t('No rooms available')} />
          </div>
        )}

        {!loading &&
          !err &&
          rooms.map(room => (
            <CardRoom
              key={room.id || room._id || room.uuid || room.name}
              src={room.thumbnail}
              title={room.name || t('Unnamed room')}
              isSelected={selectedRoomId === (room.id || room._id)}
              onSelect={() => handleSelectRoom(room)}
            />
          ))}
      </div>
      <div className="flex py-24 px-40 flex-col justify-center items-start gap-24 self-stretch room-library-right bg-fills-white">
        <div className="flex flex-col items-start gap-24 self-stretch">
          <div className="flex flex-col gap-16 items-start self-stretch">
            <span className="text-title-large">
              {t('Your room collection')}
            </span>
            <span className="text-body-medium">
              {t(
                'Select or create a personalized room template based on your actual space.'
              )}
            </span>
          </div>
          <Divider type="horizontal" className="!p-0 m-0" />
          <ButtonPrimaryLarge
            title={t('Continue')}
            disabled={!selectedRoomId}
            onClick={handleContinue}
          />
        </div>
      </div>
    </BottomSheet>
  );
};

export default RoomLibrary;

const CardRoom = ({ src, title, isSelected, onSelect }) => {
  return (
    <div
      className={`flex p-12 flex-col items-start gap-12 w-[290px] h-[322px]  shadow-dropshadow2 hover:shadow-dropshadow8 rounded-[8px] bg-fills-white border-[2px] border-solid ${
        isSelected ? ' border-outline-brand-primary' : 'border-transparent'
      }`}
      onClick={onSelect}
      style={{
        cursor: 'pointer',
      }}
    >
      <div className="flex self-stretch h-[260px] overflow-hidden">
        <img src={src} alt="" className="object-contain" />
      </div>
      <span className="text-body-large" style={{ fontWeight: 600 }}>
        {title}
      </span>
      {/* <div className="flex pt-8 justify-end items-end gap-16 self-stretch card-room-button">
        <ButtonSecondaryMedium
          title={"Giỏ hàng"}
          posIcon={<Icon.ICAdd />}
          className={"grow"}
        />
        <ButtonIconGhostMedium icon={<Icon.ICEdit />} />
        <ButtonIconGhostMedium icon={<Icon.ICMoreVert />} />
      </div> */}
    </div>
  );
};
